import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
interface ResultItem {
  type: string;
  count: number;
  percent: number;
}
interface ResultDistributionProps {
  data: ResultItem[];
}
const COLORS: Record<string, string> = {
  OBSERVADOR_ATRAPADO: '#00d4ff',
  BUSCADOR_BUCLE: '#a855f7',
  PROTECTOR_CONTROL: '#4ade80',
  REBELDE_CANSADO: '#f59e0b'
};
const LABELS: Record<string, string> = {
  OBSERVADOR_ATRAPADO: 'Observador Atrapado',
  BUSCADOR_BUCLE: 'Buscador en Bucle',
  PROTECTOR_CONTROL: 'Protector del Control',
  REBELDE_CANSADO: 'Rebelde Cansado'
};
function CustomTooltip({
  active,
  payload
}: any) {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload as ResultItem;
  return <div className="rounded-lg border border-white/10 bg-[#0c1222] px-4 py-3 shadow-xl" data-id="element-77">
      <p className="font-body text-xs font-semibold text-white" data-id="element-78">
        {LABELS[d.type] || d.type}
      </p>
      <p className="mt-1 font-body text-xs text-white/60" data-id="element-79">
        Total: <span className="text-cyan-400 font-medium" data-id="element-80">{d.count}</span> (
        {d.percent}%)
      </p>
    </div>;
}
export function ResultDistribution({
  data
}: ResultDistributionProps) {
  return <div className="rounded-xl border border-white/10 bg-white/[0.04] backdrop-blur-sm p-5" data-id="element-81">
      <h3 className="font-body text-sm font-semibold text-white mb-4" data-id="element-82">
        Distribución de Resultados
      </h3>

      {data.length > 0 ? <>
          <div className="h-56" data-id="element-83">
            <ResponsiveContainer width="100%" height="100%" data-id="element-84">
              <PieChart data-id="element-85">
                <Pie data={data} cx="50%" cy="50%" innerRadius={55} outerRadius={85} dataKey="count" nameKey="type" strokeWidth={0} data-id="element-86">
                  {data.map(entry => <Cell key={entry.type} fill={COLORS[entry.type] || '#666'} data-id="element-87" />)}
                </Pie>
                <Tooltip content={<CustomTooltip data-id="element-89" />} data-id="element-88" />
              </PieChart>
            </ResponsiveContainer>
          </div>

          <div className="mt-3 space-y-2" data-id="element-90">
            {data.map(item => <div key={item.type} className="flex items-center gap-2.5" data-id="element-91">
                <div className="h-2.5 w-2.5 rounded-full flex-shrink-0" style={{
            backgroundColor: COLORS[item.type] || '#666'
          }} data-id="element-92" />
                <span className="font-body text-xs text-white/60 flex-1" data-id="element-93">
                  {LABELS[item.type] || item.type}
                </span>
                <span className="font-body text-xs text-white/80 font-medium" data-id="element-94">
                  {item.percent}%
                </span>
              </div>)}
          </div>
        </> : <p className="font-body text-xs text-white/30 text-center py-16" data-id="element-95">
          Sin resultados completados
        </p>}
    </div>;
}